export const BRAND = "#663399";
export const BRAND_DARK = "#522a7a";

const base = {
  height: 38,
  borderRadius: 8,
  fontWeight: 600,
  display: "inline-flex",
  alignItems: "center",
  gap: 6,
  boxShadow: "none",
};

export const primaryBtn = {
  ...base,
  background: BRAND,
  borderColor: BRAND,
  color: "#fff",
  boxShadow: "0 2px 6px rgba(102,51,153,0.25)",
};

export const ghostBtn = {
  ...base,
  background: "#fff",
  borderColor: "#d9d4e2",
  color: BRAND,
};

export const dangerBtn = {
  height: 30,
  borderRadius: 7,
  fontWeight: 600,
  display: "inline-flex",
  alignItems: "center",
  gap: 5,
};

// antd v4 cannot express :hover via inline style; inject once.
let injected = false;
export const injectButtonHoverStyles = () => {
  if (injected || typeof document === "undefined") return;
  injected = true;
  const el = document.createElement("style");
  el.setAttribute("data-session-btn", "true");
  el.innerHTML = `
    .sl-btn-primary:hover, .sl-btn-primary:focus {
      background: ${BRAND_DARK} !important;
      border-color: ${BRAND_DARK} !important;
      box-shadow: 0 4px 10px rgba(102,51,153,0.35) !important;
      transform: translateY(-1px);
    }
    .sl-btn-ghost:hover, .sl-btn-ghost:focus {
      color: ${BRAND_DARK} !important;
      border-color: ${BRAND} !important;
      background: #66339908 !important;
    }
    .sl-btn-primary, .sl-btn-ghost {
      transition: all 0.18s ease;
    }
  `;
  document.head.appendChild(el);
};
